<template>
  <div class="page pink page-no-flex">
    <div class="main md-scrollbar padded w-small">
      <ForgotPassword />
    </div>
  </div>
</template>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import ForgotPassword from '../components/ForgotPassword.vue';
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
import store from "./../store";

@Component({
  components: {
    ForgotPassword, Header, Footer
  },
})
export default class ForgotPasswordPage extends Vue {
  
  constructor(){
    super()    
  }
  created(){
    //this.disableMenu()
  }

  disableMenu() {
    //store.commit("disableMenu", true);
  }

}
</script>
